export default __webpack_public_path__ + "assets/images/Data-Transparency-db229dabfc074cef385484a1614e001c.svg";